import type { ProductStatus } from '@repo/api-contracts';
import { Plus } from 'lucide-react';
import { type ReactElement, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, FilterSelect, PageHeader, SearchInput } from '@/shared/ui';
import { ProductsTable } from '@/widgets/products-table';

/** 어드민 상품 목록 페이지 — 필터·검색 상태만 소유하고 표는 위젯이 담당한다. */
export const ProductsPage = (): ReactElement => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState<ProductStatus | ''>('');

  return (
    <>
      <PageHeader
        title="상품 목록"
        description="등록한 상품을 공개·숨김합니다. 추천 순위는 랜딩 관리에서 정합니다."
        actions={
          <Button className="h-10 px-5" onClick={() => navigate('/products/editor')}>
            <Plus aria-hidden="true" />
            신규 등록
          </Button>
        }
      />

      <div className="flex flex-wrap items-center gap-2">
        <FilterSelect
          aria-label="상태 필터"
          value={statusFilter}
          onChange={(event) => {
            setStatusFilter(event.target.value as ProductStatus | '');
            setPage(1);
          }}
        >
          <option value="">전체 상태</option>
          <option value="DRAFT">등록 중</option>
          <option value="PUBLISHED">공개</option>
          <option value="HIDDEN">숨김</option>
        </FilterSelect>
        <SearchInput
          aria-label="상품명 검색"
          placeholder="상품명 검색"
          value={search}
          onChange={(event) => {
            setSearch(event.target.value);
            setPage(1);
          }}
        />
      </div>

      <ProductsTable page={page} status={statusFilter} search={search} onPageChange={setPage} />
    </>
  );
};
